import { StatusTone } from './StatusPill';

const DOTS: Record<StatusTone, string> = {
  ok: 'bg-state-ok-soft',
  warn: 'bg-state-warn',
  error: 'bg-state-err',
  info: 'bg-action-soft',
  idle: 'bg-navy-300',
};

// The halo is a 3px ring at ~18% of the dot's own colour, so it has to be
// spelled out per tone rather than derived from `currentColor`.
const HALOS: Record<StatusTone, string> = {
  ok: 'shadow-[0_0_0_3px_rgba(74,199,123,.18)]',
  warn: 'shadow-[0_0_0_3px_rgba(245,158,11,.18)]',
  error: 'shadow-[0_0_0_3px_rgba(238,90,90,.18)]',
  info: 'shadow-[0_0_0_3px_rgba(79,167,239,.18)]',
  idle: 'shadow-[0_0_0_3px_rgba(94,116,147,.18)]',
};

const StatusDot = ({ tone = 'idle', halo = false, className = '' }: {
  tone?: StatusTone,
  halo?: boolean,
  className?: string,
}) => (
  <span className={`w-1.5 h-1.5 rounded-full flex-none ${DOTS[tone]} ${halo ? HALOS[tone] : ''} ${className}`} />
)

export default StatusDot
